module.exports = __webpack_public_path__ + "img/B低通1.618c2134.png";